import { render } from "./IngredientItem.vue?vue&type=template&id=87d15e5a&scoped=true"
import script from "./IngredientItem.vue?vue&type=script&lang=js"
export * from "./IngredientItem.vue?vue&type=script&lang=js"

import "./IngredientItem.vue?vue&type=style&index=0&id=87d15e5a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-87d15e5a"

export default script